<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">Activity log</h1>
</div>
<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="row g-3 mb-5 align-items-end">
      <div class="col-12 col-xxl-5">
        <app-date-range-selector [date]="'today'" (dateChanged)="dateChanged($event)"
        [ngModel]=""></app-date-range-selector>
      </div>
      <div class="col-12 col-md-4 col-xxl-2">
        <label class="form-label" for="user">User</label>
        <select class="form-select" [(ngModel)]="filters.values['userId']" (change)="filters.onFilterChange()" id="user">
          <option [value]="''">All user</option>
          @for (user of users; track user) {
            <option [value]="user.id">{{ user }}</option>
          }
        </select>
      </div>
      <div class="col-12 col-md-3 col-xxl-2">
        <label class="form-label" for="type">Type</label>
        <app-dropdown-select [(ngModel)]="filters.values['type']" (onDropdownChange)="filters.onFilterChange()"
                             [multiple]="true" placeholder="All types" class="filter-dropdown" id="type">
          @for (type of types; track type.key) {
            <app-dropdown-select-option [value]="type.key">{{ type.label }}</app-dropdown-select-option>
          }
        </app-dropdown-select>
      </div>
      <div class="col-12 col-md-5 col-xxl-3">
        <label class="form-label" for="search">Search</label>
        <div class="d-flex gap-2 align-items-center">
          <div class="input-group">
            <input type="text" class="form-control" id="search" placeholder="Action, page or endpoint..."
                   [(ngModel)]="filters.values['search']" (change)="filters.onFilterChange()">
            <button class="btn btn-primary" type="button" (click)="filters.onFilterChange()"><i class="bi bi-search"></i></button>
          </div>
          <button type="button" class="btn btn-outline-primary" (click)="filters.saveFilters()" title="Save filters">
            <i class="bi bi-floppy"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="filters.clearFilters()"
                  title="Clear filters">
            <i class="bi bi-eraser"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="createdAt">Date</th>
            <th>User</th>
            <th>Type</th>
            <th>Action</th>
            <th>Page / endpoint</th>
            <th>Status</th>
            <th>IP</th>
            <th>Country</th>
            <th>Journey</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          @for (userEvent of userEvents; track userEvent) {
            <tr>
              <td>{{ userEvent.id }}</td>
              <td class="text-nowrap">{{ userEvent.createdAt | parisDate }}</td>
              <td class="text-nowrap">{{ userEvent.user }}</td>
              <td><span class="badge rounded-pill" [ngClass]="getTypeBadge(userEvent)">{{ getTypeLabel(userEvent) }}</span></td>
              <td>{{ userEvent.action }}</td>
              <td class="text-break small">
                @if (userEvent.method) {
                  <span class="fw-semibold">{{ userEvent.method }}</span>
                }
                {{ userEvent.path }}
              </td>
              <td>
                @if (userEvent.statusCode) {
                  <span class="badge rounded-pill" [ngClass]="getStatusBadge(userEvent)">{{ userEvent.statusCode }}</span>
                }
              </td>
              <td>{{ userEvent.ip }}</td>
              <td class="text-nowrap">@if (userEvent.country) {
                <img [ngSrc]="getFlagUrl(userEvent.country)" alt="{{ userEvent.country }}"
                  width="24" height="24">
                } {{ userEvent.country }}
              </td>
              <td>
                <button type="button" class="btn" [ngClass]="isExpandedJourney(userEvent) ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="toggleJourney(userEvent)" [disabled]="!hasJourney(userEvent)" title="Show journey">
                  <i class="bi bi-signpost-split"></i></button>
              </td>
              <td>
                <button type="button" class="btn btn-primary" (click)="toggleData(userEvent)"
                  [disabled]="!hasData(userEvent)"><i class="bi bi-eye-fill"></i></button>
              </td>
            </tr>
            @if (isExpandedJourney(userEvent)) {
              <tr>
                <td colspan="11" class="expanded-cell">
                  @if (journeyLoading) {
                    <div class="text-body-secondary small py-2">Loading journey…</div>
                  } @else if (journey; as session) {
                    <div class="journey-session my-2">
                      <div class="journey-header d-flex flex-wrap align-items-center gap-3 mb-2">
                        <span class="fw-bold">{{ session.user }}</span>
                        <span class="text-body-secondary">
                          {{ session.start | parisDate: 'dd/MM/yyyy HH:mm' }} → {{ session.end | parisDate: 'HH:mm' }}
                          ({{ getDuration(session) }})
                        </span>
                        <span class="text-body-secondary small">
                          @if (session.country) {
                            <img [ngSrc]="getFlagUrl(session.country)" alt="{{ session.country }}" width="18" height="18">
                          }
                          {{ session.ip }}
                        </span>
                      </div>
                      <div class="journey-steps">
                        @for (step of session.steps; track step; let last = $last) {
                          <button type="button" class="journey-step" [ngClass]="'journey-step-' + step.type"
                                  [class.journey-step-failed]="step.failed" [class.active]="expandedStep === step"
                                  [class.journey-step-current]="isJourneyCurrentStep(step)"
                                  (click)="toggleStep(step)">
                            <span class="journey-step-label">
                              <i class="bi" [ngClass]="getStepIcon(step)"></i>
                              {{ step.label }}
                              @if (step.count > 1) {
                                <span class="badge rounded-pill text-bg-secondary ms-1">×{{ step.count }}</span>
                              }
                            </span>
                            @if (step.detail) {
                              <span class="journey-step-detail">{{ step.detail }}</span>
                            }
                            <span class="journey-step-time">{{ step.start | parisDate: 'HH:mm:ss' }}</span>
                          </button>
                          @if (!last) {
                            <i class="bi bi-chevron-right journey-arrow"></i>
                          }
                        }
                      </div>
                      @if (expandedStep) {
                        <div class="data">
                          <pre>{{ getStepEventsData(expandedStep) }}</pre>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="text-body-secondary small py-2">No journey found for this event.</div>
                  }
                </td>
              </tr>
            }
            @if (isExpandedData(userEvent)) {
              <tr>
                <td colspan="11" class="expanded-cell">
                  <div class="data">
                    <pre>{{ getData(userEvent) }}</pre>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
  </div>
</div>
